import React from 'react';
import CabinetShell from '../../components/UI/CabinetShell/cabinetShell';
import ThemeComponent from './DecorateComponents/themeComponent';
import { useTheme } from '../../hooks/useTheme';
import "./settings.css"
import SettingsNav from '../../components/UI/SettingsNav/settingsNav';
const Theme = () => {
  const { theme, setTheme } = useTheme()
  const [activeLink, setActiveLink] = React.useState(null);

  React.useEffect(() => {
    setActiveLink(`${(window.location.pathname).substring((window.location.pathname).lastIndexOf('/')+1)}`);
  })
 
  const handleLightThemeClick = () => {
    setTheme('light')
  }
  const handleDarkThemeClick = () => {
    setTheme('dark')
  }

    return (
        <CabinetShell title="Оформление" floor={false}>
            <SettingsNav activeLink={activeLink} setActiveLink={setActiveLink}/>

            <div className='settingsContent'>
              <ThemeComponent onToggleOff={handleLightThemeClick} onToggle={handleDarkThemeClick} theme={theme}/>
            </div>

        </CabinetShell>
    );
};


export default Theme;

